module.exports = __webpack_public_path__ + "static/media/d.380eb88e.jpg";